import script from "./KPIItem.vue?vue&type=script&setup=true&lang=js"
export * from "./KPIItem.vue?vue&type=script&setup=true&lang=js"

import "./KPIItem.vue?vue&type=style&index=0&id=2b6d945f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b6d945f"]])

export default __exports__